"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FuseToolbarModule = /** @class */ (function () {
    function FuseToolbarModule() {
    }
    return FuseToolbarModule;
}());
exports.FuseToolbarModule = FuseToolbarModule;
